import styled from "styled-components";

export const titleStyle = {
  fontWeight: 500,
  fontSize: "22px",
  fontFamily: "Inter, sans-serif",
  lineHeight: "1.2em"
};

export const companyNameStyle = {
  fontWeight: 500,
  fontSize: "14px",
  fontFamily: "Inter, sans-serif"
};

export const pageNameStyle = {
  fontWeight: 300,
  fontSize: "14px",
  fontFamily: "Inter, sans-serif"
};

export const PostEditorLinkedInWrapper = styled.div`
  width: 580px;
  background-color: #fff;
  box-shadow: 0px 2px 4px 0px #1516331f;
  border-radius: 4px;
`;

export const HeaderWrapper = styled.div`
  position: relative;
  padding: 15px;
  text-align: left;
`;

export const HeaderPicture = styled.img`
  width: 100%;
  height: 75px;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
`;

export const Logo = styled.img`
  position: absolute;
  top: -20px;
  left: 20px;
  width: 70px;
  height: 70px;
`;

export const HeaderIcons = styled.img`
  width: 60px;
  margin-left: auto;
  margin-bottom: 35px;
  display: block;
`;

export const TitleWrapper = styled.div`
  display: flex;
  margin-left: -6px;
`;

export const SaveButton = styled.div`
  background: white;
  color: rgb(0, 114, 176);
  width: 150px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  border-radius: 4px;
  border: 1px solid rgb(0, 114, 176);
  margin-right: 10px;
`;

export const ApplyButton = styled.a`
  background: rgb(0, 114, 176);
  width: 150px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  border-radius: 4px;
  color: white;
  &:hover {
    color: white;
    background: rgb(0, 85, 130);
  }
`;

export const CompanyWrapper = styled.div`
  display: flex;
  font-size: 15px;
  margin: 10px 0 10px -6px;
`;

export const HeaderInfo = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const HeaderInfoText = styled.div`
  color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
`;

export const Underline = styled.div`
  width: 50%;
  height: 1px;
  background-color: rgba(191, 191, 191, 0.3);
  margin-top: 10px;
`;

export const BodyWrapper = styled.div`
  width: 100%;
`;

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SelectListsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const HTMLEditorWrapper = styled.div`
  max-width: 618px;
  margin-left: -10px;
`;

export const Requirements = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  padding: 0 15px 15px;
`;

export const RequirementsDetails = styled.div`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 15px;
`;

export const SelectListWrapper = styled.div`
  margin-bottom: 20px;
  width: 48%;
`;
